export enum TrackingElement {
  PAGE_PRODUCT = 'product selection',
  PAGE_DOCUMENT = 'document selection',
  PAGE_EXPORT = 'export settings',
  PART_MYEUH = 'my endress+hauser',
  PART_CONTENT_LINK = 'content_link',
  PART_WIZARD = 'product document wizard',
  PART_QUOTES = 'quotes',
  PART_ORDERS = 'orders',
  PART_LOGGIN = 'logged_in',
  PART_CHECKBOX = 'checkbox',
  PART_SHOW_MORE = 'show_more',
  ACTION_SELECT_ALL = 'select all',
  ACTION_SHOW_MORE = 'show more',
  ACTION_SHOW_LESS = 'show less',
  ACTION_RESET_FILE = 'reset file structure',
  ACTION_RESET_FOLDER = 'reset folder structure',
  ACTION_CREATE = 'create',
  ACTION_NEXT_STEP = 'next step',
  ACTION_BACK = 'back',
  SUBTYPE_CHECKED = 'checked_remember settings',
  SUBTYPE_UNCHECKED = 'unchecked_remember settings',
  SUBTYPE_NEXT_STEP = 'next step',
  SUBTYPE_BACK = 'back',
  SUBTYPE_MORE = 'more',
  SUBTYPE_LESS = 'less',
  SUBTYPE_CREATE = 'create',
}
